import { ReactNode } from "react";

export interface ApiResponse<T> {
	statusCode: number;
	message: string;
	data: T;
	total?: number;
	successCode?: string;
	skip?: number;
	take?: number;
	extraData: any;
}

export interface ApiErrorResponse<T> {
	code: string;
	data: T;
	message: string;
	status: number;
}

export interface RouteEl {
	label: string;
	path: string;
	key: string;
	icon?: ReactNode;
	component?: ReactNode;
	children?: RouteEl[];
	permissions?: string[];
	hidden?: boolean;
}

export type Lang = "en" | "zh" | "km";

export enum GENDER {
	MALE = 1,
	FEMALE,
	UNKNOWN,
}

export enum USER_TYPE {
	CUSTOMER = 1,
	MERCHANT,
	STAFF,
}

export enum STATUS {
	ENABLE = 1,
	DISABLE,
}

export interface BaseComponentProps {
	className?: string;
}

export type BaseStatus = "enable" | "disable";

export interface BreadcrumbType {
	label: string;
	path?: string;
	icon?: React.ReactNode;
}

export interface Address {
	name: string;
	id: number;
}

export interface CarMediaError {
	internal: string;
	external: string;
	video: string;
}

export type LANGUAGES_TYPE = "en" | "zh" | "km";

export interface Translation {
	[key: string]: string;
}

export type BasePagination<T> = {
	items: T[];
	total: number;
};

export type LocationPoint = {
	x: number;
	y: number;
};
